import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GraphsComponent } from './graphs/graphs.component';
import { GraphMenuPanelComponent } from './graphs/graph-menu-panel/graph-menu-panel.component';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {ReportSelectionService} from './services/reportSelection.service';
import {ReportDataCacheService} from './services/reportDataCache.service';
import {ChartSpinnerHandlerService} from './services/chartSpinnerHandler.service';
import { GraphAreaPanelComponent } from './graphs/graph-area-panel/graph-area-panel.component';
import {MaterialModule} from '../material.module';
import {HighchartModule} from '../utils/highchart/highchart.module';
import { GraphFilterPanelComponent } from './graphs/graph-filter-panel/graph-filter-panel.component';
import {InfraModule} from 'ac-infra';
import {ThresholdsModule} from './thresholds/thresholds.module';
import {FormsModule} from '@angular/forms';
import {LayoutModule} from '../components/layout/layout.module';



@NgModule({
  declarations: [GraphsComponent, GraphMenuPanelComponent, GraphAreaPanelComponent, GraphFilterPanelComponent],
  imports: [
    CommonModule,
    NzMenuModule,
    ThresholdsModule,
    MaterialModule,
    HighchartModule,
    InfraModule,
    FormsModule,
    LayoutModule
  ],
  providers: [
    ReportSelectionService,
    ReportDataCacheService,
    ChartSpinnerHandlerService
  ]
})
export class StatisticsModule { }
